/**
 * <cart-preview>: the personalization Preview window on the cart page (feature 026,
 * specs/026-cart-page-design/contracts/cart-ui.md §2). Dawn's DetailsModal (details-modal.js) with one
 * change: it focuses the dialog itself, because this dialog has no text input for DetailsModal to focus.
 * Without JavaScript the <details> element simply opens inline.
 */
if (!customElements.get('cart-preview') && typeof DetailsModal !== 'undefined') {
  customElements.define(
    'cart-preview',
    class CartPreview extends DetailsModal {
      open(event) {
        this.onBodyClickEvent = this.onBodyClickEvent || this.onBodyClick.bind(this);
        event.target.closest('details').setAttribute('open', true);
        document.body.addEventListener('click', this.onBodyClickEvent);
        document.body.classList.add('overflow-hidden');
        const dialog = this.detailsContainer.querySelector('[tabindex="-1"]');
        trapFocus(dialog, dialog);
      }
    }
  );
}
